/**
 * Copyright Mántum All Rights Reserved.
 */
export const KEY_CANCEL = 'cancel';
export const KEY_COMPLETE = 'complete';
export const KEY_CONTENT = 'content';
export const KEY_CURSOR = 'cursor';
export const KEY_DATA = 'data';
export const KEY_DATA_SOURCE = 'dataSource';
export const KEY_SELECTED_ROWS_DATA = 'selectedRowsData';
export const KEY_SELECTED_ROWS_KEYS = 'selectedRowKeys';
export const KEY_SELECTED_ROWS_DATA_MASTER_DETAIL =
    'selectedRowsDataMasterDetail';
export const KEY_TYPE_EMAIL = 'email';
export const KEY_TYPE_SELECT = 'select';
export const KEY_INDEX = 'index';
export const KEY_ALERT = 'alert';
